import { fetchGet } from '~utilities/fetch';

export async function countryListRequest(): Promise<Response> {
    return fetchGet('/countries');
}
